/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Ext_Device_TitleInputs */

const en_creator_ext_device_title = /** @type {(inputs: Creator_Ext_Device_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External Device Control`)
};

const fr_creator_ext_device_title = /** @type {(inputs: Creator_Ext_Device_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controle des appareils externes`)
};

const de_creator_ext_device_title = /** @type {(inputs: Creator_Ext_Device_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steuerung externer Geräte`)
};

const it_creator_ext_device_title = /** @type {(inputs: Creator_Ext_Device_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllo del dispositivo esterno`)
};

const ru_creator_ext_device_title = /** @type {(inputs: Creator_Ext_Device_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление внешним устройством`)
};

const es_creator_ext_device_title = /** @type {(inputs: Creator_Ext_Device_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control de dispositivos externos`)
};

const zh_cn2_creator_ext_device_title = /** @type {(inputs: Creator_Ext_Device_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外部设备控制`)
};

const ja_creator_ext_device_title = /** @type {(inputs: Creator_Ext_Device_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外部デバイス制御`)
};

const hi_creator_ext_device_title = /** @type {(inputs: Creator_Ext_Device_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाह्य उपकरण नियंत्रण`)
};

const pt_pt2_creator_ext_device_title = /** @type {(inputs: Creator_Ext_Device_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controle de Dispositivo Externo`)
};

/**
* | output |
* | --- |
* | "External Device Control" |
*
* @param {Creator_Ext_Device_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_ext_device_title = /** @type {((inputs?: Creator_Ext_Device_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Ext_Device_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_ext_device_title(inputs)
	if (locale === "de") return de_creator_ext_device_title(inputs)
	if (locale === "it") return it_creator_ext_device_title(inputs)
	if (locale === "ru") return ru_creator_ext_device_title(inputs)
	if (locale === "es") return es_creator_ext_device_title(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_ext_device_title(inputs)
	if (locale === "ja") return ja_creator_ext_device_title(inputs)
	if (locale === "hi") return hi_creator_ext_device_title(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_ext_device_title(inputs)
	return en_creator_ext_device_title(inputs)
});